/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Locale } from '@app/settings/locales/locales.model';
import { Model } from '@app/shared/models/model.model';

@Injectable({
  providedIn: 'root',
})
export class LocalesService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/locales', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((locale: Locale) => {
          return new Locale().deserialize(locale);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(locale: Locale): Observable<Locale> {
    return this.http.put('v1/locales/' + locale.id, locale).pipe(
      map((response: HttpResponse) => {
        return new Locale().deserialize(response.data);
      })
    );
  }

  store(locale: Locale): Observable<Locale> {
    return this.http.post('v1/locales', locale).pipe(
      map((response: HttpResponse) => {
        return new Locale().deserialize(response.data);
      })
    );
  }

  show(id: number): Observable<Model> {
    return this.http.get('v1/locales/' + id).pipe(
      map((response: HttpResponse) => {
        return new Locale().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/locales/' + id);
  }
}
